import { FBTabsType } from "../../../data/admin-data";

interface FBTabsItemProps {
    handleSelectedTab: (id: number) => void;
    tab: FBTabsType;
    activeTab: number;
}

export default function FBTabsItem({ activeTab, handleSelectedTab, tab }: FBTabsItemProps) {
    return (
        <button
            key={tab.id}
            className={`flex-shrink-0 px-4 py-1 text-sm font-semibold capitalize transition-all duration-200 
                ${
                activeTab === tab.id
                    ? "border-b-2 border-cbColor text-cbColor font-medium"
                    : "border-b-2 border-transparent text-black hover:border-gray-300"
                }`}
            onClick={() => handleSelectedTab(tab.id)}
        >
            {tab.labelName}
        </button>
    )
}
